import { render, staticRenderFns } from "./ParentProfile.vue?vue&type=template&id=7f33ae59&scoped=true"
import script from "./ParentProfile.vue?vue&type=script&lang=js"
export * from "./ParentProfile.vue?vue&type=script&lang=js"
import style0 from "./ParentProfile.vue?vue&type=style&index=0&id=7f33ae59&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f33ae59",
  null
  
)

export default component.exports